module.exports = __webpack_public_path__ + "static/EnmTX_BosRufus_L_A_cl-9215531f1348f5a5aaefc6ab24469bd3.gif";